document.addEventListener("DOMContentLoaded", () => {

    let loop = setInterval(() => {
        let a = document.querySelectorAll('.select-option')
        if (a.length) {
            a.forEach(element => {
                element.addEventListener('click', () => {
                    let price = document.querySelector('[bss-b2b-product-form] [data-block-id ="price"]')
                    if (price) {
                         price.classList.add('bss-disable')
                    }
                    const productForm = document.querySelector('[bss-b2b-product-form]');
                    if (productForm) {
                        if (typeof BSS_B2B == 'object') {

                            BSS_B2B.observer.productSubject.notifyObserver(
                                'VariantChange',
                                'VariantSelectChange', {
                                    productForm
                                }
                            );
                            setTimeout(() => {
                                if (price) {
                                  price.classList.remove('bss-disable')
                                }
                            }, 1000);
                        }
                    }
                });
            });
            clearInterval(loop);
        }
    }, 100)
    setTimeout(() => {
        clearInterval(loop);
    }, 7000)

    let a = document.querySelector('.product--add-to-cart-button')
    if (a) {
        a.addEventListener('click', () => {
            if (typeof BSS_B2B == 'object') {
                setTimeout(() => {
                    BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
                    BSS_B2B.observer.cartSubject.listenCartCheckout()
                }, timeout);

            }
        })
    }
});
